import configureStore, { history } from 'common/tools/configure-store';
import reducer from 'client/reducers';

export { history };

const preState = window.__PRELOADED_STATE__ || {};
const localStorageChoice =
	localStorage && localStorage.getItem('c') ? { ...JSON.parse(localStorage.getItem('c')) } : {};

export default configureStore({ ...preState, choice: localStorageChoice }, reducer);
